import React from 'react'
import { connect } from 'react-redux'
import Toggle from 'react-toggle'
import EsimActions from '../../Redux/EsimRedux'

class UpdateEsim extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      form: {
        image_file: props.detail.image_file,
        description: props.detail.description,
        is_featured: props.detail.is_featured,
        is_active: props.detail.is_active
      },
    }
  }

  _inputChange = (event, field) => {
    let val = event.target.value
    let form = { ...this.state.form }
    form[field] = val
    this.setState({ form })
  }

  _toggleChange = (event, field) => {
    let val = event.target.checked
    let form = { ...this.state.form }
    form[field] = val
    this.setState({ form })
  }

  _submit = (event) => {
    event.preventDefault()
    let form = { ...this.state.form }
    const data = { id: this.props.detail.id, form }
    this.props.submit(data)
    setTimeout(() => {
      this.props.closeModal()
    }, 250)
  }

  render() {
    return (
      <section className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update eSIM - {this.props.detail.name}</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Featured</label>
            </div>
            <div className='col-9'>
              <Toggle checked={this.state.form.is_featured} onChange={event => this._toggleChange(event, "is_featured")} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Active</label>
            </div>
            <div className='col-9'>
              <Toggle checked={this.state.form.is_active} onChange={event => this._toggleChange(event, "is_active")} />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Description</label>
            </div>
            <div className='col-9'>
              <textarea className='form-control' rows={15} value={this.state.form.description} onChange={event => this._inputChange(event, "description")} />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </section>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  submit: (data) => dispatch(EsimActions.esimUpdateRequest(data))
})

export default connect(stateToProps, dispatchToProps)(UpdateEsim)



// WEBPACK FOOTER //
// ./src/Containers/Esim/UpdateEsim.js